<template>
  <div :class="$style.wrapper"><slot /></div>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.wrapper {
  margin-top: $space-150;
}
</style>
<script setup lang="ts"></script>
